<template>
  <section style="height: 100%">
    <v-app-bar app color="primary" dark>
      <img
        :src="require('../assets/logo-novaxs-sm.png')"
        alt="NovaXS"
        width="30"
      />

      <v-toolbar-title class="pl-5">Buscar</v-toolbar-title>
    </v-app-bar>
    <v-container fluid app>
      <v-text-field
        solo
        hide-details
        clearable
        prepend-inner-icon="search"
        flat
        v-model="searchText"
        placeholder="Pesquise pelo nome de um produto"
        background-color="grey lighten-3"
      ></v-text-field>
    </v-container>
    <v-divider />
    <div style="height:calc(100vh - 178px); overflow: auto">
      <v-list three-line v-if="products.length > 0 && !loading" class="pt-0">
        <template v-for="(item, index) in products">
          <v-divider :key="index"></v-divider>
          <v-list-item
            :key="item.title"
            :disabled="item.pdv.availability === 'UNAVAILABLE'"
            @click="$router.push({ name: 'product', params: { product: item } })"
          >
            <v-list-item-content class="d-flex align-start">
              <v-list-item-title
                v-text="item.name"
                class="pb-0 overflow-subtitle wrap-text"
                style="height: auto !important;"
              />
              <v-list-item-subtitle
                class="overflow-subtitle"
                :style="
                  item.pdv.availability === 'UNAVAILABLE'
                    ? 'color: rgba(0, 0, 0, 0.38);'
                    : ''
                "
                v-html="item.description"
              ></v-list-item-subtitle>
              <v-list-item-action-text
                v-if="notOnlyDigitalMenu()"
                v-html="item.pdv.availabilityHTML"
              ></v-list-item-action-text>
            </v-list-item-content>
            <v-list-item-action class="mt-2 mb-1">
              <v-avatar size="60">
                <v-img
                  :style="
                    item.pdv.availability === 'UNAVAILABLE'
                      ? 'opacity: 0.38;'
                      : ''
                  "
                  :src="item.image"
                ></v-img>
              </v-avatar>
              <span class="subheading mt-1" style="color: green;">{{
                $toBrl(parseInt(item.price, 10))
              }}</span>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <div v-else-if="loading">
        <template v-for="i in 4">
          <div :key="`loader-${i}`">
            <v-layout row class="pl-5 pr-5 pt-1 pb-1">
              <v-flex xs9 class="pt-3">
                <v-skeleton-loader type="text" />
                <v-skeleton-loader type="text" />
              </v-flex>
              <v-flex xs3 class="d-flex justify-end align-center">
                <v-skeleton-loader type="avatar" width="60" />
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </div>
        </template>
      </div>
      <v-sheet v-else class="fill-height d-flex align-center justify-center">
        <v-layout column justify-center>
          <v-flex class="d-flex justify-center">
            <v-icon color="grey" size="60">
              search
            </v-icon>
          </v-flex>
          <v-flex class="d-flex justify-center">
          <span class="subheading grey--text">
            Por enquanto não há nada aqui
          </span>
          </v-flex>
        </v-layout>
      </v-sheet>
    </div>
  </section>
</template>

<script>
import ProductService from "../services/productService";

export default {
  name: "Search",
  data() {
    return {
      loading: false,
      products: [],
      searchText: ""
    };
  },
  watch: {
    searchText: async function(val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.search(val);
      }, 500);
    }
  },
  methods: {
    notOnlyDigitalMenu() {
      return localStorage.getItem("onlyDigitalMenu").toString() !== "true";
    },
    async search(normalized_name) {
      this.loading = true;
      const res = await new ProductService().getProducts({
        normalized_name: {
          $like:
            "%" +
            normalized_name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase() +
            "%"
        }
      });
      const res2 = await new ProductService().getProductsCombos({
        normalized_name: {
          $like:
              "%" +
              normalized_name
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase() +
              "%"
        }
      });
      this.loading = false;
      this.products = [];

      res.data.products.forEach(product => {
        if (!product.availability) {
          product.pdvs.forEach(productPDV => {
            const p = JSON.parse(JSON.stringify(product));
            p.pdv = productPDV;

            let sub = ``;

            const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
            const configuration = accessPoint.configurations.filter(
              configuration =>
                configuration.pdvs.filter(pdv => productPDV.id === pdv.id)
                  .length > 0
            )[0];

            if (configuration && configuration.availability)
              p.pdv.availability = configuration.availability;
            if (p.pdv.availability === "UNAVAILABLE")
              sub += `<span style="width: calc(100% - 74px); color: rgba(0, 0, 0, 0.38)">Indisponível no ${p.pdv.name}!</span>`;
            else if (p.pdv.availability === "NODELIVERY")
              sub += `<span style="width: calc(100% - 74px);  color: orange"> Retirada no ${p.pdv.name}*</span>`;
            else if (p.pdv.availability === "DELIVERY")
              sub += `<span style="width: calc(100% - 74px);  color: black">Entregue pelo ${p.pdv.name}</span>`;
            else return;
            p.originalPrice = p.price;
            this.products.push(p);
            sub += "</div>";
            p.pdv.availabilityHTML = sub;
          });
        }
      });
      res2.data.products.forEach(product => {
        if (!product.availability) {
          product.pdvs.forEach(productPDV => {
            const p = JSON.parse(JSON.stringify(product));
            p.pdv = productPDV;

            let sub = ``;

            const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
            const configuration = accessPoint.configurations.filter(
              configuration =>
                configuration.pdvs.filter(pdv => productPDV.id === pdv.id)
                  .length > 0
            )[0];

            if (configuration && configuration.availability)
              p.pdv.availability = configuration.availability;
            if (p.pdv.availability === "UNAVAILABLE")
              sub += `<span style="width: calc(100% - 74px); color: rgba(0, 0, 0, 0.38)">Indisponível no ${p.pdv.name}!</span>`;
            else if (p.pdv.availability === "NODELIVERY")
              sub += `<span style="width: calc(100% - 74px);  color: orange"> Retirada no ${p.pdv.name}*</span>`;
            else if (p.pdv.availability === "DELIVERY")
              sub += `<span style="width: calc(100% - 74px);  color: black">Entregue pelo ${p.pdv.name}</span>`;
            else return;
            p.originalPrice = p.price;
            this.products.push(p);
            sub += "</div>";
            p.pdv.availabilityHTML = sub;
          });
        }
      });
    }
  }
};
</script>

<style scoped></style>
